module.exports = __webpack_public_path__ + "static/img/T7386.11638592.png";